import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { roleService } from 'services';

const initialState = {
  data: {},
  detailData: {},
  filter: {
    name: '',
    code: '',
  },
  statusList: 'idle',
  statusDetail: '',
  statusDelete: '',
  statusSubmit: '',
  droplist: [],
  statusDroplist: '',
  menuList: [],
  statusMenuList: ''
};

export const getList = createAsyncThunk(
  'role/fetchList',
  async (data) => {
    const response = await roleService.list(data);
    return response;
  }
);

export const getDetail = createAsyncThunk(
  'role/fetchById',
  async (data) => {
    const response = await roleService.show(data);
    return response;
  }
);

export const deleteData = createAsyncThunk(
  'role/fetchDelete',
  async (data) => {
    const response = await roleService.remove(data);
    return response;
  }
);

export const createData = createAsyncThunk(
  'role/fetchCreate',
  async (data) => {
    const response = await roleService.create(data);
    return response;
  }
);

export const editData = createAsyncThunk(
  'role/fetchUpdate',
  async (data) => {
    const response = await roleService.update(data);
    return response;
  }
);

export const getAll = createAsyncThunk(
  'role/fetchAllData',
  async (data) => {
    const response = await roleService.droplist(data);
    return response;
  }
);

export const getMenu = createAsyncThunk(
  'role/fetchMenu',
  async (data) => {
    const response = await roleService.menuList(data);
    return response;
  }
);

export const roleSlice = createSlice({
  name: 'role',
  initialState: initialState,
  reducers: {
    setFilter: (state, action) => {
      const data = action.payload;
      state.filter = data;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if(typeof payload === 'string'){
        state[payload] = initialState[payload];
      }else if(Array.isArray(payload)){
        payload.forEach(item => 
          state[item] = initialState[item]
        );
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getList.pending, (state) => {
        state.statusList = 'loading';
      })
      .addCase(getList.fulfilled, (state, action) => {
        state.statusList = 'success';
        state.data = action.payload;
      })
      .addCase(getList.rejected, (state) => {
        state.statusList = 'error';
      })
      .addCase(getDetail.pending, (state) => {
        state.statusDetail = 'loading';
      })
      .addCase(getDetail.fulfilled, (state, action) => {
        state.statusDetail = 'success';
        state.detailData = action.payload;
      })
      .addCase(getDetail.rejected, (state) => {
        state.statusDetail = 'error';
      })
      .addCase(deleteData.pending, (state) => {
        state.statusDelete = 'loading';
      })
      .addCase(deleteData.fulfilled, (state, action) => {
        state.statusDelete = 'success';
      })
      .addCase(deleteData.rejected, (state) => {
        state.statusDelete = 'error';
      })
      .addCase(createData.pending, (state) => {
        state.statusSubmit = 'loading';
      })
      .addCase(createData.fulfilled, (state) => {
        state.statusSubmit = 'success';
      })
      .addCase(createData.rejected, (state) => {
        state.statusSubmit = 'error';
      })
      .addCase(editData.pending, (state) => {
        state.statusSubmit = 'loading';
      })
      .addCase(editData.fulfilled, (state) => {
        state.statusSubmit = 'success';
      })
      .addCase(editData.rejected, (state) => {
        state.statusSubmit = 'error';
      })
      .addCase(getAll.pending, (state) => {
        state.statusDroplist = 'loading';
      })
      .addCase(getAll.fulfilled, (state, action) => {
        state.statusDroplist = 'success';
        state.droplist = action.payload;
      })
      .addCase(getAll.rejected, (state) => {
        state.statusDroplist = 'error';
      })
      .addCase(getMenu.pending, (state) => {
        state.statusMenuList = 'loading';
      })
      .addCase(getMenu.fulfilled, (state, action) => {
        state.statusMenuList = 'success';
        state.menuList = action.payload;
      })
      .addCase(getMenu.rejected, (state) => {
        state.statusMenuList = 'error';
      });
  }
});

export const { setFilter, resetData } = roleSlice.actions;

const roleReducer = roleSlice.reducer;
export default roleReducer;